<template>
  <div class="app-container">
    <PageTitle title="提现记录" ref="pageTitle" :city_show="false" />
    <div class="filter-container">
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="姓名"
        v-model="listQuery.guide_name"
        @change="handleGuideName"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="手机号"
        v-model="listQuery.guide_mobile"
        @change="handleGuideMobile"
      ></el-input>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.status"
        placeholder="状态"
        @change="handleStatus"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="待打款" :value="1"></el-option>
        <el-option label="已打款" :value="2"></el-option>
        <el-option label="打款中" :value="3"></el-option>
        <el-option label="打款失败" :value="4"></el-option>
      </el-select>
      <el-date-picker
        v-model="listQuery.apply_date"
        type="date"
        placeholder="申请提现日期"
        value-format="yyyy-MM-dd"
        style="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
        @change="handleApplyDate"
      ></el-date-picker>
      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-button
      v-if="sendBtnShow"
      type="primary"
      size="mini"
      @click="handleCashOutBatch"
      style="margin-bottom: 10px"
      >批量打款</el-button
    >
    <Table :data="list" :columns="columns" :loading="listLoading" @changeSelect="changeSelect">
      <template v-slot:selection>
        <el-table-column width="50" align="center" type="selection" :selectable="checkSelectable">
        </el-table-column>
      </template>
      <template v-slot:name>
        <el-table-column label="导游姓名" width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.guide.name }} </template>
        </el-table-column>
      </template>
      <template v-slot:mobile>
        <el-table-column label="导游手机号" width="120" align="center">
          <template slot-scope="scope"> {{ scope.row.guide.mobile }} </template>
        </el-table-column>
      </template>
      <template v-slot:method>
        <el-table-column label="提现方式" width="100" align="center">
          <template slot-scope="scope"> {{ ['', '银行卡', '微信'][scope.row.method] }} </template>
        </el-table-column>
      </template>
      <template v-slot:card_no>
        <el-table-column label="银行卡号" width="150" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.method == 1">
              {{ scope.row.bank.bank_name }}｜{{ scope.row.bank.card_no }}
            </template>
          </template>
        </el-table-column>
      </template>
      <template v-slot:add_time>
        <el-table-column label="申请提现时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="success" :underline="false">{{ scope.row.add_time }}</el-link>
          </template>
        </el-table-column>
      </template>
      <template v-slot:status>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{ ['', '待打款', '已打款', '打款中', '打款失败'][scope.row.status] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:handle_time>
        <el-table-column label="打款时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="success" :underline="false">{{ scope.row.handle_time }}</el-link>
          </template>
        </el-table-column>
      </template>
      <template v-slot:action>
        <el-table-column label="操作" minWidth="130">
          <template slot-scope="scope">
            <el-col :span="24"
              ><el-button
                type="primary"
                size="mini"
                @click="handleAutomatic(scope.row.id)"
                v-if="scope.row.status == 1 || scope.row.status == 4"
                >系统自动打款</el-button
              ></el-col
            >
            <el-col :span="24" style="margin-top: 5px"
              ><el-button
                type="primary"
                size="mini"
                @click="handleCashOut(scope.row.id)"
                v-if="scope.row.method !== 2 && (scope.row.status == 1 || scope.row.status == 4)"
                >手动打款完成</el-button
              ></el-col
            >
          </template>
        </el-table-column>
      </template>
    </Table>

    <div
      class="pagination-container"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div style="font-weight: bold">
        汇总金额: <span>{{ total_amount || 0 }}</span
        >元
      </div>
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
  </div>
</template>

<script>
import { getCashOutList, cashOut, cashOutAuto, cashOutBatch } from '@/api/cashOut'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'FinanceIndex',
  components: {
    PageTitle
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        city: ''
      },
      total_amount: 0,
      sendBtnShow: false,
      columns: [
        { type: 'selection', slot: 'selection' },
        {
          type: 'index',
          align: 'center',
          label: '序号',
          width: '50'
        },
        {
          label: '导游姓名',
          slot: 'name'
        },
        {
          label: '导游手机号',
          slot: 'mobile'
        },
        {
          label: '提现金额',
          prop: 'amount',
          width: '120',
          align: 'center'
        },
        {
          label: '提现方式',
          slot: 'method'
        },
        {
          label: '银行卡号',
          slot: 'card_no'
        },
        {
          label: '申请提现时间',
          slot: 'add_time'
        },
        {
          label: '状态',
          slot: 'status'
        },
        {
          label: '打款时间',
          slot: 'handle_time'
        },
        {
          label: '操作',
          slot: 'action'
        }
      ],
      ids: []
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      getCashOutList(this.listQuery).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
        this.total_amount = res.data.total_amount
      })
    },
    /**
     * @description: 判断是否可选
     * @return {*}
     */
    checkSelectable(row) {
      return row.status == 1
    },
    handleCashOutBatch() {
      const _this = this
      _this
        .$confirm('是否确认批量打款当前选中项？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          cashOutBatch({ record_ids: _this.ids }).then(() => {
            _this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            _this.fetchData()
          })
        })
        .catch(() => {})
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleGuideName(e) {
      this.listQuery.guide_name = e
      this.handleFilter()
    },
    handleGuideMobile(e) {
      this.listQuery.guide_mobile = e
      this.handleFilter()
    },
    handleStatus(e) {
      this.listQuery.status = e
      this.handleFilter()
    },
    handleApplyDate(e) {
      this.listQuery.apply_date = e
      this.handleFilter()
    },
    /**
     * @description:
     * @return {*}
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        guide_name: '',
        guide_mobile: '',
        status: '',
        apply_date: ''
      }
      this.fetchData()
    },
    /**
     * @description: 选择行
     * @return {*}
     */
    changeSelect(e) {
      this.sendBtnShow = !!e.length > 0
      this.ids = e.map((item) => item.id)
    },
    /**
     * @description: 打款完成
     * @param {*} uuid
     * @return {*}
     */
    handleCashOut(uuid) {
      this.$confirm('确认该项目已打款完成？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cashOut(uuid, {}).then(() => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    },
    handleAutomatic(uuid) {
      this.$confirm('确认该项目已完成自动打款？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cashOutAuto(uuid, {}).then(() => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
</style>
